
  

  import React, { useState } from 'react';
import {MDBContainer, MDBCol, MDBRow, MDBBtn, MDBIcon, MDBInput, MDBCheckbox, MDBModalHeader, MDBModalTitle, MDBModalBody, MDBModal, MDBModalDialog, MDBModalContent, MDBCardText } from 'mdb-react-ui-kit';
import SignUp from './Signup';
import { Field, Form, Formik } from 'formik';
export const metadata = {
  title: 'Sign In - Open PRO',
  description: 'Page description',
}
  export default function SignIn() {
    const [reg,setreg]=useState(false)
    const onHide=()=>{
        setreg(true)
    }
    const [resetpass,setresetpass]=useState(false)
    const toggleshow=()=>{setresetpass(!resetpass)}
    return (
      <MDBContainer fluid className="p-3 my-5 h-custom">
        {
          !reg?
        
        <><MDBRow>

              <MDBCol col='10' md='6'>
                <img src="https://mdbcdn.b-cdn.net/img/Photos/new-templates/bootstrap-login-form/draw2.webp" class="img-fluid" alt="Sample" />
              </MDBCol>

              <MDBCol col='4' md='6'>

                <div className="d-flex flex-row align-items-center justify-content-center">
                  <p className="lead fw-normal mb-0 me-3 p-2">Sign-in</p>             
                </div>
                <Formik initialValues={{email:"",password:""}} onSubmit={async (values)=>{
                    console.log("value",values)
                   // const apiurl = "https://thk9n7oewa.execute-api.ap-south-1.amazonaws.com/firstdeploy/login?email="+values.email+"&password="+values.password;
            
                   try {
                    const url = `https://thk9n7oewa.execute-api.ap-south-1.amazonaws.com/firstdeploy/login?email=${values.email}&password=${values.password}`;
                    console.log("url", url);
                    
                    const response = await fetch(url, {
                      mode: "no-cors",
                      method: 'POST',
                      headers: {
                        'Content-Type': 'application/json'
                      },
                      
                    });
                    
                    console.log("Response status:", response.status);
                    
                    const body = await response.json();
                    console.log("Response body:", body);
                    
                    if (!response.ok) {
                      throw new Error("Network response was not ok");
                    }
                    
                    const jsonResponse = JSON.parse(body);
                    console.log("Response:", jsonResponse);
                    
                    if (jsonResponse.errorMsg) {
                      console.log("Error Body", jsonResponse.errorMsg);
                      throw new Error(jsonResponse.errorMsg);
                    } else {
                      return jsonResponse;
                    }
                  } catch (error) {
                    console.error(error);
                    throw new Error(error.message);
                  }
                  
                    
                }}>
                   {({setFieldValue})=>(
                <Form>
                 

                 
                <>
                <Field as={MDBInput} required wrapperClass='mb-4' name="email" label='Email address' id='formControlLg' type='email' size="lg" />
                <Field as={MDBInput} required wrapperClass='mb-4' name="password" label='Password' id='formControlLg' type='password' size="lg" />
                <div className="d-flex justify-content-between mb-4">
                        <MDBCheckbox name='flexCheck' value='' id='flexCheckDefault' label='Remember me' />
                        <a href="#!" onClick={() => {
                          setresetpass(true);
                        } }>Forgot password?</a>
                      </div><div className='text-center text-md-start mt-4 pt-2'>
                          <MDBBtn className="mb-0 px-5" size='lg' type='Submit'>Login</MDBBtn>
                          <p className="small fw-bold mt-2 pt-1 mb-2">Don't have an account? <a href="#!" onClick={onHide} className="link-danger">Register</a></p>
                        </div></>
                 
                </Form>
                 )}
                </Formik>
              </MDBCol>

            </MDBRow><div className="d-flex flex-column flex-md-row text-center text-md-start justify-content-between py-4 px-4 px-xl-5 bg-primary">

                <div className="text-white mb-3 mb-md-0">
                  Copyright © 2024. All rights reserved.
                </div>

                <div>

                  <MDBBtn tag='a' color='none' className='mx-3' style={{ color: 'white' }}>
                    <MDBIcon fab icon='facebook-f' size="md" />
                  </MDBBtn>

                  <MDBBtn tag='a' color='none' className='mx-3' style={{ color: 'white' }}>
                    <MDBIcon fab icon='twitter' size="md" />
                  </MDBBtn>

                  <MDBBtn tag='a' color='none' className='mx-3' style={{ color: 'white' }}>
                    <MDBIcon fab icon='google' size="md" />
                  </MDBBtn>

                  <MDBBtn tag='a' color='none' className='mx-3' style={{ color: 'white' }}>
                    <MDBIcon fab icon='linkedin-in' size="md" />
                  </MDBBtn>

                </div>

              </div></>
      :<SignUp />
      
        }
          <MDBModal  open={resetpass} setOpen={setresetpass} tabIndex='0'>
        <MDBModalDialog centered  size="sm">
          <MDBModalContent>
             <MDBModalHeader>
             <MDBModalTitle style={{justifyContent:"center"}}>Forget Password</MDBModalTitle>
              <MDBBtn className='btn-close' color='none' onClick={()=>{
                toggleshow();
                setresetpass(!resetpass)
              }}></MDBBtn>
            </MDBModalHeader>
            <MDBModalBody>
              <MDBCardText>Please Enter your email we send you insructions for reset password on your email</MDBCardText>
            <MDBInput wrapperClass='mb-4' label='Email address' id='formControlLg' type='email' size="lg" />
            <MDBBtn className="mb-1" >Send Instructions</MDBBtn>
            </MDBModalBody>
            </MDBModalContent>
            </MDBModalDialog>
            </MDBModal>
      </MDBContainer>
    );
  }
  